import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, AreaChart, Area } from 'recharts';
import { generateTimeSeriesData, MOCK_PRODUCTS } from '@/lib/adapters/mockData';
import { Euro, ShoppingCart, TrendingUp } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface SalesConversionTabProps {
  clientId: string;
  filters: FilterState;
}

export function SalesConversionTab({ clientId, filters }: SalesConversionTabProps) {
  const timeSeriesData = generateTimeSeriesData(30);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <TrendingUp className="mr-2 h-5 w-5" />
            CA & Commandes - Évolution
          </CardTitle>
          <CardDescription>
            Tendance des ventes et du volume de commandes sur 30 jours
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={timeSeriesData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Area type="monotone" dataKey="revenue" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
              <Line type="monotone" dataKey="orders" stroke="#82ca9d" />
            </AreaChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Top/Flop Produits</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {MOCK_PRODUCTS.map((product) => (
              <div key={product.asin} className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <h4 className="font-medium">{product.title}</h4>
                  <p className="text-sm text-muted-foreground">{product.asin}</p>
                </div>
                <div className="text-right space-y-1">
                  <div className="font-medium">{product.revenue.toLocaleString('fr-FR')} €</div>
                  <div className="text-sm text-muted-foreground">
                    {product.orders} commandes • Conv: {(product.conversion * 100).toFixed(2)}%
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}